import React, { useContext, useRef, useState } from 'react';
import { Upload } from 'antd';
import { LoadingOutlined, CameraOutlined, DeleteOutlined, FileOutlined } from '@ant-design/icons';
import { getBase64 } from '../../../shared/utils/utils';
import { colors } from '../../../styles/theme';
import { ThemeContext } from '../../../shared/contexts/Theme.context';
import CamSnapshot from './CamSnapshot';
import isMobile from 'ismobilejs';

const defaultButtonStyle = {
  fontSize: '20px',
  backgroundColor: colors.primary,
  padding: '10px',
  borderRadius: '50%',
  cursor: 'pointer',
};
const placeholder = '/static/img/placeholder.png';

export default function DocumentInput({ field, setFileValue }) {
  const { state: theme } = useContext(ThemeContext);
  const buttonStyle = {
    ...defaultButtonStyle,
    color: theme.secondaryColor,
  };

  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [showCamera, setShowCamera] = useState(true);
  const uploadRef = useRef();
  const isMobileDevice = isMobile().any;

  const handleChange = info => {
    setShowCamera(false);
    if (info.file.status === 'uploading') setLoading(true);
    else if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, imageUrl => {
        setLoading(false);
        setImageUrl(imageUrl);
      });
    }
  };
  const handleBefore = file => setFileValue(field.key, { file, field });
  const handleDelete = () => {
    setFileValue(field.key, { file: null, field });
    setImageUrl(null);
    setShowCamera(false);
  };
  const handleCameraChange = (url, file) => {
    setImageUrl(url);
    setFileValue(field.key, { file, field });
    setShowCamera(false);
  };
  return (
    <>
      {showCamera ? (
        <CamSnapshot handleChange={handleCameraChange} theme={theme}></CamSnapshot>
      ) : null}
      <div className="btn-container">
        {imageUrl ? (
          <div onClick={handleDelete}>
            <DeleteOutlined style={{ ...buttonStyle, marginRight: 5 }} />
          </div>
        ) : null}

        <Upload
          accept="image/*"
          listType="text"
          onChange={handleChange}
          beforeUpload={handleBefore}
          method="GET"
        >
          <>
            {loading ? (
              <LoadingOutlined style={buttonStyle} />
            ) : (
              <div ref={ref => (uploadRef.current = ref)}>
                {isMobileDevice ? (
                  <CameraOutlined style={buttonStyle} />
                ) : (
                  <FileOutlined style={buttonStyle} />
                )}
              </div>
            )}
          </>
        </Upload>

        {!isMobileDevice ? (
          <CameraOutlined
            onClick={() => setShowCamera(!showCamera)}
            style={{ ...buttonStyle, marginLeft: 5 }}
          />
        ) : null}
      </div>

      <style jsx>{`
        .image-container {
          width: 100%;
          margin-top: 16px;
          border-radius: 20px;
          margin-bottom: 10px;
          background-color: #f5f5f5;
          cursor: pointer;
          text-align: center;
        }

        .image-container .upload-img {
          width: 100%;
          height: 150px;
          object-fit: contain;
        }

        .image-container .upload-img.placeholder {
          max-width: 50px;
        }
      `}</style>
      <style jsx global>{`
        .btn-container {
          display: flex;
          justify-content: flex-end;
        }

        .ant-upload-list {
          display: none;
        }
      `}</style>
    </>
  );
}
